import React, { useEffect } from "react";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
} from '@mui/material';

const ConfirmDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  confirmationText,
  setConfirmationText,
  errorText,
}) => {
  useEffect(() => {
  if (open) {
    setConfirmationText('');
    }
  }, [open, setConfirmationText]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmar eliminación</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Para eliminar el calendario, escribe <strong>eliminar</strong> en la casilla de texto y presiona confirmar.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          label="Escribe 'eliminar'"
          type="text"
          fullWidth
          variant="outlined"
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
          error={!!errorText}
          helperText={errorText}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={onConfirm} color="error">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
